import { WorkOrder, WorkOrderFilter } from '@idea2app/ai-work-order-service';

import { TableModel } from './Base';
import userStore from './User';

export class WorkOrderModel extends TableModel<WorkOrder, WorkOrderFilter> {
    baseURI = 'work-order';
    client = userStore.client;
}

export default new WorkOrderModel();
